import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  getAllFactoriesByGroupID,
  getAllLeaveRequestDetailsByGroupFactory,
  SaveRejectedLeaveRequest,
  SaveApprovedLeaveRequest,
  getEmployeeRegistrationNumbersByGroupFactory,
  getEmployeeLeaveType,
  SaveLeaveFormDetails,
  getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID,
  getEmployeeLeaveFormDetailsByLeaveRefNo,
  getEmployeeRemainingLeaveValue,
  getAllocatedDays,
  updateLeaveFormDetails,
  GetNonApprovalLeavesCount,
  getEmployeeAvailability,
  getEmployeeLeaveTypeRaw,
  getEmployeeDetailsByRegistrationNumber,
  SaveApprovedLeaveRequest,
  SaveApprovedIndividualLeaveRequest,
  SaveRejectedIndividualLeaveRequest
};

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
  let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  let factoryArray = []
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getAllLeaveRequestDetailsByGroupFactory(model) {
  const response = await CommonGet('/api/LeaveForm/GetLeaveRequestDetailsByGroupFactory', 
    "groupID=" + parseInt(model.groupID) + 
    "&factoryID=" + parseInt(model.factoryID) + 
    "&registrationNumber=" + model.registrationNumber);
  return response;
}

async function SaveRejectedLeaveRequest(model) {
  const response = await CommonPost('/api/LeaveForm/SaveRejectedLeaveRequest', null, model);
  return response;
}

async function SaveApprovedLeaveRequest(model) {
  const response = await CommonPost('/api/LeaveForm/SaveApprovedLeaveRequest', null, model);
  return response;
}

async function getEmployeeRegistrationNumbersByGroupFactory(groupID, factoryID) {
  const response = await CommonGet('/api/Leave/GetEmployeeRegistrationNumbersByGroupFactory', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response; 
}

async function getEmployeeLeaveType() {
  let response = await CommonGet('/api/Employee/GetEmployeeLeaveType', null);
  let leaveTypeArray = []
  for (let item of Object.entries(response.data)) {
    leaveTypeArray[item[1]["employeeLeaveTypeID"]] = item[1]["employeeLeaveTypeName"]
  }
  return leaveTypeArray;
}

async function getEmployeeLeaveFormDetailsByEmployeeLeaveRequestID(leaveRefNo) {
  const response = await CommonGet('/api/LeaveForm/GetLeaveRequestDetailsByEmployeeLeaveRequestID', 
    "LeaveRefNo=" + parseInt(leaveRefNo));
  return response.data;
}

async function getEmployeeLeaveFormDetailsByLeaveRefNo(leaveRefNo) {
  const response = await CommonGet('/api/LeaveForm/GetEmployeeLeaveFormDetailsByLeaveRefNo', 
    "LeaveRefNo=" + parseInt(leaveRefNo));
  return response;
}

async function getAllocatedDays(leaveTypeID, employeeID) {
  return await CommonGet(
    '/api/LeaveForm/GetAllocatedDays',
    `LeaveTypeID=${parseInt(leaveTypeID)}&EmployeeID=${parseInt(employeeID)}`
  );
}

async function SaveApprovedIndividualLeaveRequest(data) {
  const response = await CommonPost('/api/LeaveForm/SaveApprovedIndividualLeaveRequest', null, data);
  return response;
}

async function SaveRejectedIndividualLeaveRequest(data) {
  const response = await CommonPost('/api/LeaveForm/SaveRejectedIndividualLeaveRequest', null, data);
  return response;
}

async function updateLeaveFormDetails(model) {
  const response = await CommonPost('/api/LeaveForm/UpdateLeaveFormDetails', null, model);
  return response;
}

async function SaveLeaveFormDetails(model) {
  const response = await CommonPost('/api/LeaveForm/SaveLeaveRequestDetails', null, model);
  return response;
}

async function GetNonApprovalLeavesCount(model) {
  const response = await CommonPost('/api/LeaveForm/GetNonApprovalLeavesCount', null, model);
  return response.data || 0;
}

async function getEmployeeAvailability(groupID, factoryID, regNo) {
  const response = await CommonGet('/api/LeaveForm/GetEmployeeAvailability', 
    'groupID=' + groupID + "&factoryID=" + factoryID + "&registrationNumber=" + regNo);
  return response;
}

async function getEmployeeRemainingLeaveValue(leaveTypeID, employeeID) {
  const response = await CommonGet('/api/LeaveForm/GetRemainingLeaveBalance', 
    "LeaveTypeID=" + parseInt(leaveTypeID) + "&RegistrationNumber=" + parseInt(employeeID));
  return response;
}

async function getEmployeeLeaveTypeRaw() {
  let response = await CommonGet('/api/Employee/GetEmployeeLeaveType', null);
  return response.data;
}

async function getEmployeeDetailsByRegistrationNumber(groupID, factoryID, registrationNumber) {
  const response = await CommonGet('/api/LeaveForm/GetEmployeeDetailsByRegistrationNumber', 
    "groupID=" + parseInt(groupID) + 
    "&factoryID=" + parseInt(factoryID) + 
    "&registrationNumber=" + registrationNumber);
  return response;
}